const REMEMBER_KEY = "remember_auth";

export function saveRememberMe(authState) {
  localStorage.setItem(REMEMBER_KEY, JSON.stringify(authState));
}

export function loadRememberMe() {
  const saved = localStorage.getItem(REMEMBER_KEY);
  return saved ? JSON.parse(saved) : null;
}

export function clearRememberMe() {
  localStorage.removeItem(REMEMBER_KEY);
}
